import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FlatArea} from '../../../models/flat-area.model';
import * as _ from 'underscore';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'app-flat-area-editor',
  templateUrl: './flat-area-editor.component.html',
  styleUrls: ['./flat-area-editor.component.scss']
})
export class FlatAreaEditorComponent implements OnInit {

  @Input() parentForm: FormGroup;
  @Output() flatAreaListChanged = new EventEmitter();
  selectedFlatArea: FlatArea;
  editMode: boolean;
  flatAreas: FlatArea[] = [];

  constructor() {
    this.selectedFlatArea = new FlatArea();
  }

  ngOnInit() {

    this.flatAreas = this.parentForm.value['flatAreas'];
    if(!this.flatAreas){
      this.flatAreas = [];
    }
  }

  isFormValid() {
    return this.selectedFlatArea && this.selectedFlatArea.size && this.selectedFlatArea.size > 0 && this.selectedFlatArea.coverage && this.selectedFlatArea.name;
  }

  deleteItem(flatArea) {
    this.flatAreas = _.without(this.flatAreas, flatArea);
    this.parentForm.controls['flatAreas'].patchValue(this.flatAreas);
  }

  selectItem(flatArea) {

    if (flatArea.flatAreaId === this.selectedFlatArea.flatAreaId) {
      this.selectedFlatArea = new FlatArea();
      this.editMode = false;
      return;
    }

    this.editMode = true;
    this.selectedFlatArea = flatArea;
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.flatAreas, event.previousIndex, event.currentIndex);
    this.parentForm.controls['flatAreas'].patchValue(this.flatAreas);
  }


  addOrEditSelectedFlatArea() {

    if (this.editMode) {
      let itemToUpdateIndex = this.flatAreas.findIndex((item) => item.flatAreaId === this.selectedFlatArea.flatAreaId);
      this.flatAreas[itemToUpdateIndex] = this.selectedFlatArea;
      this.editMode = false;
      this.selectedFlatArea = new FlatArea();
    } else {
      this.flatAreas.push(this.selectedFlatArea);
      this.selectedFlatArea = new FlatArea();
    }
    this.parentForm.controls['flatAreas'].patchValue(this.flatAreas);
  }

}
